import { render, staticRenderFns } from "./asideIconMenu.vue?vue&type=template&id=ca670ca0&scoped=true"
import script from "./asideIconMenu.vue?vue&type=script&lang=js"
export * from "./asideIconMenu.vue?vue&type=script&lang=js"
import style0 from "./asideIconMenu.vue?vue&type=style&index=0&id=ca670ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca670ca0",
  null
  
)

export default component.exports